import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import axios from 'axios';
import { environment } from '../../../../environments/environment';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-new-qualification',
  templateUrl: './edit-pre2004jumps.component.html',
  styleUrls: ['./edit-pre2004jumps.component.scss']
})
export class EditPre2004JumpsComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  
  mode = 'Create';

  // define qualification object
  pre2004JumpsAdjustments = {
    PersonnelId: 0,
    JumperName: '',
    Fire: 0,
    Ground: 0,
    Proficiency: 0,  
    Single: 0,
    Rescue: 0,
    Other: 0,
    Total: 0
  };

  // define form sections
  sections = [
    {
      title: 'Pre-2004 Jumps Adjustments Information for ',
      data: [
        {
          maxlength: 4,
          required: true,
          input: true,
          placeholder: 'Fire',
          key: 'fire'
        },
        {
          maxlength: 4,
          required: true,
          input: true,
          placeholder: 'Ground',
          key: 'ground'
        },
        {
          maxlength: 4,
          required: true,
          input: true,
          placeholder: 'Proficiency',
          key: 'proficiency'
        },
        {
          maxlength: 4,
          required: true,
          input: true,
          placeholder: 'Single Resource',
          key: 'single'
        },
        {
          maxlength: 4,
          required: true,
          input: true,
          placeholder: 'Rescue',
          key: 'rescue'
        },
        {
          maxlength: 4,
          required: true,
          input: true,
          placeholder: 'Other',
          key: 'other'
        }
      ]
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    // if we see an '/:id' instead of '/new' in the URL,
    // we are in "update" mode instead of "create" mode
    let url = window.location.href;
    let id = url.slice(url.lastIndexOf('/') + 1, url.length);
    if (id.includes(';')) {
      id = url.slice(url.lastIndexOf('/') + 1, url.indexOf(';'));
    }
    if (id !== 'new') {
      this.beginUpdateMode(id);
    }
  }

  beginUpdateMode = async (id) => {
    this.mode = 'Update';
    let pre2004Adjustments = await axios.get(environment.API_URL + '/jumpers/getjumperpre2004jumpsdata?jumperId=' + id, {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.pre2004JumpsAdjustments = pre2004Adjustments.data[0];

    var xpath = "//span[text()='Pre-2004 Jumps Adjustments Information for ']";
    var matchSpan = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
    if (matchSpan.singleNodeValue) {
      matchSpan.singleNodeValue.textContent = 'Pre-2004 Jumps Adjustments Information for ' + this.pre2004JumpsAdjustments.JumperName;
    }
  };

  submitForm = (data) => {
    let userId = this.userInfo.id;
    const options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };

    //ghh-test
    var ghh1 = JSON.stringify(this.pre2004JumpsAdjustments);

    let url =
      environment.API_URL + '/jumpers/updatepre2004jumpsdata';
    axios
      .post(url, this.pre2004JumpsAdjustments, options)
      .then((response) => {
        // pop success toast and redirect to list
        this.toast.show('Updated Pre-2004 Jumps Adjustments', 'success');
        this.router.navigate(['/pre2004jumps']);
      })
      .catch((error) => {
        this.toast.show('Unable to Update Pre-2004 Jumps Adjustments', 'error');
        console.dir(error);
      });

  };
}
